import type { InterviewState } from "./types";

/** Askable fields only — matches what the progress meter and the mobile "Data n/7" badge count (§17). */
export function selectAskableFieldIds(state: InterviewState): string[] {
  return state.template.fields.filter((f) => f.askable).map((f) => f.id);
}

export function selectFilledAskableCount(state: InterviewState): number {
  return selectAskableFieldIds(state).filter((id) => state.fields[id]?.status === "filled").length;
}

export function selectProgress(state: InterviewState): { filled: number; total: number } {
  const ids = selectAskableFieldIds(state);
  return { filled: selectFilledAskableCount(state), total: ids.length };
}

export function selectIsPaused(state: InterviewState): boolean {
  return state.safety.status === "paused";
}

export function selectHasUnexportedData(state: InterviewState): boolean {
  return selectFilledAskableCount(state) > 0;
}
